export default __webpack_public_path__ + "static/exhibit-c-3-020aa86870032bac1944fa5291e68c62.jpg";